export default __webpack_public_path__ + "static/media/md-card-bg-power-bi.6369188c.png";